import React from 'react'
import style from '../../style.module.less'
import { InfoCircleFilled } from '@ant-design/icons'
import { Flex } from 'hljd'

export default store => [
  {
    title: '菜单名称',
    dataIndex: 'name',
    key: 'name',
    width: 100,
    render: (name, { reason, id, sensitive_tip }) => {
      if (store.keys == 3) {
        return (
          <div>
            <div>{name}</div>
            <p>ID: {id}</p>
            {sensitive_tip && (
              <Flex className={style.bannedWords}>
                <InfoCircleFilled style={{ marginRight: 4, marginTop: 3 }} />
                {sensitive_tip}
              </Flex>
            )}
            <div>
              <span style={{ color: 'red' }}>未通过原因：</span>
              {reason}
            </div>
          </div>
        )
      }

      return (
        <>
          <p>{name}</p>
          <p>ID: {id}</p>
          {sensitive_tip && (
            <Flex className={style.bannedWords}>
              <InfoCircleFilled style={{ marginRight: 4, marginTop: 3 }} />
              {sensitive_tip}
            </Flex>
          )}
        </>
      )
    }
  },
  {
    title: '菜品数量',
    dataIndex: 'series_count',
    key: 'series_count',
    width: 100
  },
  {
    title: '每桌单价',
    dataIndex: 'price',
    key: 'price',
    width: 100,
    render: price => <div>{price}/桌</div>
  },
  {
    title: '推荐菜',
    dataIndex: 'recommend_food',
    key: 'recommend_food',
    width: 100
  },
  /*  {
    title: '服务费',
    dataIndex: 'service_fee_option',
    key: 'service_fee_option',
    width: 100,
    render: service_fee_option => {
      if (!service_fee_option) {
        return ''
      }
      switch (service_fee_option.type) {
        case 1:
          return <div>面议</div>
        case 2:
          return <div>{service_fee_option.show_value}%</div>
        case 3:
          return <div>{service_fee_option.show_value}/桌</div>
        case 4:
          return '无'
      }
    }
  },*/
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    width: 100,
    sorter: true
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    key: 'updated_at',
    width: 100,
    sorter: true
  },
  {
    title: '操作',
    key: 'operation',
    width: 120,
    render: (operation, { id }) => {
      const { keys } = store
      return (
        <div className={style.buttons}>
          {(keys == 1 || keys == 4) && (
            <a onClick={store.menufromsale(id)}>{keys == 1 ? '下' : '上'}架</a>
          )}

          <a onClick={store.edit(id)}>编辑</a>
          <a onClick={store.delLive(id)} className={style.red}>
            删除
          </a>
        </div>
      )
    }
  }
]
